var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_35887",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blocked_icon",
    "data-name": "blocked icon",
    transform: "translate(15 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35248",
    "data-name": "Group 35248"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -9)",
    filter: "url(#Path_35887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35887-2",
    "data-name": "Path 35887",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0",
    transform: "translate(15 9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35888",
    "data-name": "Path 35888",
    d: "M9.073,18.146h0a9.073,9.073,0,1,1,6.416-2.658A9.084,9.084,0,0,1,9.073,18.146Zm0-15.765a6.692,6.692,0,0,0,0,13.385v0a6.692,6.692,0,0,0,0-13.385Z",
    transform: "translate(2.17 15) rotate(-45)",
    fill: "#dd4b64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8419",
    "data-name": "Rectangle 8419",
    width: 15.416,
    height: 2.761,
    transform: "translate(8.686 19.832) rotate(-45)",
    fill: "#dd4b64"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.84f2cf405aad2b06122d163cbd079926.svg";
export { ForwardRef as ReactComponent };